import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {UserTagProvider} from "../../providers/user-tag/user-tag";
import {StatusBar} from "@ionic-native/status-bar";

/**
 * Generated class for the AppWhoQuestionnairePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-who-questionnaire',
  templateUrl: 'app-who-questionnaire.html',
})
export class AppWhoQuestionnairePage {

  answers: Array<number>;
  currentQuestion: number = 0;
  result: number = 0;

  result1Text: string = '';
  result2Text: string = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, public contentTranslation: ContentTranslationProvider, public tag: UserTagProvider, public statusBar: StatusBar) {
    this.answers = new Array<number>();
  }

  ionViewDidLoad() {
    this.result1Text = this.tag.compile(this.contentTranslation.translateContent('WHO Questionnaire End Result 1'), {})
    this.result2Text = this.tag.compile(this.contentTranslation.translateContent('WHO Questionnaire End Result 2'), {})

    this.statusBar.hide();
  }

  ionViewWillLeave() {
    if((window as any).statusBarHiddenByDefault == false) {
      this.statusBar.show();
    }
  }

  nextQuestion() {
    if(this.currentQuestion>0 && this.currentQuestion<6) {
      if(!this.answers[this.currentQuestion]) {
        return ;
      }
    }

    if(this.currentQuestion == 5) {
      var sum = 0;
      for(var k in this.answers) {
        var ans = this.answers[k];
        sum += (6-ans);
      }

      if(sum >=13) {
        this.result = 1;
      } else {
        this.result = 2;
      }
    }

    this.currentQuestion++;
  }
  prevQuestion() {
    this.currentQuestion--;
  }

  selectValue(question, value) {
    this.answers[question] = value;
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-who-questionnaire/app-who-questionnaire.ts